import { render, staticRenderFns } from "./MarketingTool.vue?vue&type=template&id=4aac0ae4&"
import script from "./MarketingTool.vue?vue&type=script&lang=js&"
export * from "./MarketingTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports